import React, { Component } from "react";
import Navbar from "@nsgscholarship/components/Navbar";
import SubNavbar from "@nsgscholarship/components/SubNavbar";
import Banner from "@nsgscholarship/components/Banner";
import About from "@nsgscholarship/components/About";
import Apply from "@nsgscholarship/components/Apply";
// import Time from "@nsgscholarship/components/Time";
import Time from "@nsgscholarship/components/TimeNew";
import RequiredInfo from "@nsgscholarship/components/RequiredInfo";
import Faq from "@nsgscholarship/components/Faq";
import ApplyNowButton from "@nsgscholarship/components/ApplyNowButton";
import StageTwo from "@nsgscholarship/components/StageTwo";
import Attention from "@nsgscholarship/components/Attention";
import Footer from "@nsgscholarship/components/Footer";
import Application from "@/modules/Application";
import MessageFn from './message'
import Translator from '@/modules/translator';
import "./App.scss";

const collectionId = 327;

class App extends Component {
  constructor(props) {
    super(props);
    this.url = `${window.location.origin}/nsgprogram`;
    this.imageURL = `${window.location.origin}/nsgprogram/images/seo-cover-2023.jpg`;
    this.state = {
      message: MessageFn(),
    }
  }

  getHelmetScript() {
    const message = this.state.message.application;

    return [{
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "Event",
        name: "Shopee Taiwan 東南亞新二代扶持計畫",
        description: message.desc,
        image: this.imageURL,
        startDate: message.startDate,
        endDate: message.endDate,
        url: this.url,
        audience: {
          audienceType: "在台定居且設有中華民國戶籍者，且其父或母一方，現或曾與我國國人結婚, 且父或母曾有或現有東南亞國家(包含但不限於越南、寮國、柬埔寨、泰國、緬甸、馬來西亞、汶萊、新加坡、印尼、東帝汶、菲律賓)之國籍, 現就讀國內公、私立大專院校(不含五專前三年)之在學學生(日間部、進修學士班)，就學滿一學期(含)以上者。"
        },
        location: {
          "@type": "Place",
          name: "Shopee Taiwan",
          address: "Online",
        }
      })
    }]
  }

  render() {
    let Message = this.state.message;
    const script = this.getHelmetScript();
    return (
      <div className="App">
        <Application
          message={Message.application}
          url={this.url}
          imageURL={this.imageURL}
          script={script}
          viewport={true}
        />
        <Navbar message={Message.navbar} />
        <SubNavbar message={Message.subNavbar} />
        <Banner message={Message.banner}/>
        <About message={Message.about}/>
        <Apply message={Message.apply}/>
        <Time message={Message.time}/>
        <RequiredInfo message={Message.requiredInfo}/>
        <StageTwo message={Message.stageTwo}/>
        <Attention message={Message.attention}/>
        <Faq message={Message.faq}/>
        <ApplyNowButton />
        <Footer message={Message.footer} />
      </div>
    );
  }
}

export default Translator(App, MessageFn, { locale: 'zh-Hant' }, { collectionId });;
